import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TIERS } from "@/lib/content";

export const PricingTiers = ({ onSelectPackage }) => {
  const handleBook = (id) => {
    onSelectPackage(id);
    if (window.__lenis) {
      window.__lenis.scrollTo("#book");
    } else {
      document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="services" className="py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="font-mono-alt text-xs font-semibold uppercase tracking-[0.2em] text-[#B45309]">
            01 — Services & Pricing
          </p>
          <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-[#111827] sm:text-3xl lg:text-4xl">
            Two cleans. Zero guesswork.
          </h2>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-[#4B5563]">
            Flat pricing for any car, truck, or SUV. Pick your clean and we handle the rest — at your location.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-8 md:grid-cols-2">
          {TIERS.map((tier, i) => (
            <Reveal key={tier.id} delay={i * 0.12}>
              <div
                data-testid={`pricing-card-${tier.id}`}
                className={`relative flex h-full flex-col rounded-3xl border bg-white p-8 transition-shadow hover:shadow-xl hover:shadow-[#131519]/5 sm:p-10 ${
                  tier.popular ? "border-[#D97706]" : "border-[#E5E7EB]"
                }`}
              >
                {tier.popular && (
                  <span className="absolute -top-3 left-8 rounded-full bg-[#D97706] px-4 py-1 font-mono-alt text-[10px] font-semibold tracking-[0.2em] text-white">
                    MOST POPULAR
                  </span>
                )}
                <h3 className="font-display text-xl font-semibold tracking-tight text-[#111827] sm:text-2xl">
                  {tier.name}
                </h3>
                <p className="mt-2 text-sm text-[#6B7280]">{tier.tagline}</p>
                <div className="mt-6 flex items-end gap-1">
                  <span className="font-display text-5xl font-extrabold tracking-tight text-[#111827]">
                    ${tier.price}
                  </span>
                  <span className="mb-1.5 text-sm text-[#9CA3AF]">/ vehicle</span>
                </div>
                <ul className="mt-8 flex-1 space-y-3.5">
                  {tier.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm leading-relaxed text-[#4B5563]">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#FEF3C7]">
                        <Check size={12} className="text-[#B45309]" strokeWidth={3} />
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={tier.id === "basic" ? "book-basic-button" : "book-premium-button"}
                  onClick={() => handleBook(tier.id)}
                  className={`mt-10 w-full rounded-full py-3.5 text-sm font-semibold transition-colors ${
                    tier.popular
                      ? "bg-[#D97706] text-white hover:bg-[#B45309]"
                      : "border border-[#131519] text-[#131519] hover:bg-[#131519] hover:text-white"
                  }`}
                >
                  Book {tier.name}
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
